<template>
  <div class="header-selector" :class="{ 'settings-tab-text-icon': right }">
    <button
      v-for="option in options"
      :class="{ selected: option.name == selected }"
      :key="option.name"
      @click="$emit('change', option.name)"
    >
      {{ option.text }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    selected: String,
    right: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss">
.header-selector {
  button {
    position: relative;
    top: -3px;
    padding: 3px 10px 1px;
    border: none;
    border-radius: 4px;
    background-color: #c2c2d6;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: bold;
    line-height: 20px;
    color: white;

    &.selected {
      background-color: #00a6cb;
    }
    &:not(:last-child) {
      margin-right: 12px;
    }
  }
}
</style>
